module.exports = __webpack_public_path__ + "img/octagon-divide.d222fab4.svg";